import { handleActions } from 'redux-actions';
import produce from 'immer';
import { clearSelectedSubsidies, selectSubsidy, setCheckSubsidyResult, setCheckedTravellers, setSubsidiesError, setSubsidiesLoading, setSubsidiesResultsOpen, setSubsidiesState } from './actions';
export const initialState = {
    selectSubsidiesError: null,
    subsidiesResultInitialPrice: null,
    availableSubsidiesByPassengers: {},
    subsidiesResultByPassengersSegments: {},
    selectedSubsidies: {},
    isLoading: false,
    resultsOpen: false,
    checkedTravellers: []
};
export default handleActions({
    [setSubsidiesState.toString()]: (state, { payload }) => (Object.assign({}, payload)),
    [setSubsidiesLoading.toString()]: (state, { payload }) => (Object.assign(Object.assign({}, state), { isLoading: payload })),
    [setSubsidiesResultsOpen.toString()]: (state, { payload }) => (Object.assign(Object.assign({}, state), { resultsOpen: payload })),
    [setCheckSubsidyResult.toString()]: (state, { payload }) => {
        if (!payload) {
            return state;
        }
        return produce(state, draft => {
            const slice = {};
            draft.subsidiesResultInitialPrice = payload.initialOrderPrice;
            for (const segment of payload.segments) {
                for (const responsePassenger of segment.travellers) {
                    const travellerId = responsePassenger.traveller.id;
                    const segmentId = segment.segment.id;
                    if (!slice[travellerId]) {
                        slice[travellerId] = {};
                    }
                    if (!slice[travellerId][segmentId]) {
                        slice[travellerId][segmentId] = [];
                    }
                }
            }
            for (const segment of payload.segments) {
                for (const responsePassenger of segment.travellers) {
                    slice[responsePassenger.traveller.id][segment.segment.id].push({
                        segmentId: segment.segment.id,
                        id: responsePassenger.subsidyInfo.subsidyId,
                        discount: responsePassenger.subsidyInfo.discount,
                        initialPrice: responsePassenger.subsidyInfo.initialPrice,
                        rejectMessage: responsePassenger.subsidyInfo.rejectMessage,
                        resultPrice: responsePassenger.subsidyInfo.resultPrice
                    });
                    draft.subsidiesResultByPassengersSegments = slice;
                }
            }
        });
    },
    [setSubsidiesError.toString()]: (state, { payload }) => {
        return Object.assign(Object.assign({}, state), { selectSubsidiesError: payload });
    },
    [clearSelectedSubsidies.toString()]: (state) => {
        return produce(state, draft => {
            for (const [passengerId] of Object.entries(state.selectedSubsidies)) {
                draft.selectedSubsidies[passengerId] = [];
            }
        });
    },
    [selectSubsidy.toString()]: (state, { payload }) => {
        return produce(state, draft => {
            const payloadSubsidy = { subsidyId: payload.subsidyId, segmentId: payload.segmentId };
            const alreadySelectedSubsidyIndex = draft.selectedSubsidies[payload.passengerId].findIndex(alreadySelected => alreadySelected.subsidyId === payloadSubsidy.subsidyId &&
                alreadySelected.segmentId === payloadSubsidy.segmentId);
            if (alreadySelectedSubsidyIndex !== -1) {
                draft.selectedSubsidies[payload.passengerId].splice(alreadySelectedSubsidyIndex, 1);
            }
            else {
                draft.selectedSubsidies[payload.passengerId].push(payloadSubsidy);
            }
        });
    },
    [setCheckedTravellers.toString()]: (state, { payload }) => {
        return Object.assign(Object.assign({}, state), { checkedTravellers: payload });
    }
}, initialState);
